// extracted by mini-css-extract-plugin
export var gif = "_lq-0";